/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Trash, PencilSimpleLine, Plus, MagnifyingGlass, FunnelSimple, DotsThreeVertical } from "@phosphor-icons/react";
import api from "../../utils/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Eye, Download, Users, ChartBar, Clock, CheckCircle } from "lucide-react";
import ContentLoader from "react-content-loader";
import Select from "react-select";

const TemplateDetails = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [ID, setID] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [modules, setModules] = useState([]);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [subjectInputs, setSubjectInputs] = useState({});
  const [error, setError] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [templateDetails, setTemplateDetails] = useState("");
  const [userPermissions, setUserPermissions] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const [templateFilter, setTemplateFilter] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);

  const getPageFromUrl = () => {
    const params = new URLSearchParams(location.search);
    const page = parseInt(params.get("page"), 10);
    return isNaN(page) || page < 1 ? 1 : page;
  };

  useEffect(() => {
    auth();
    fetchData(getPageFromUrl());
  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("limit", itemsPerPage);
      fd.append("pageNo", 12);

      const response = await api.post("user/userCurl", fd);
      if (response.data && response.data.data.length > 0) {
        setUserPermissions(response.data.data[0]);
      }
    } catch (error) {
      setUserPermissions({});
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  const TableLoader = ({ rows = 10, columns = 5 }) => (
    <tbody>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} style={{ textAlign: "center", padding: "16px" }}>
              <div
                style={{
                  height: "20px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s infinite"
                }}
              ></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  async function fetchData(page = 1, term = "") {
    setDataLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getTemplateDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("page", page);
      fd.append("limit", itemsPerPage);

      if (term.trim() !== "") {
        fd.append("searchTerm", term.trim());
      }

      const response = await api.post("templates/templateCurl", fd);
      if (response.data && Array.isArray(response.data.getTemplateDetails)) {
        setFetchedData(response.data.getTemplateDetails);
        setCurrentPage(page);
        setTotalItems(response.data.totalPages * itemsPerPage);
      } else {
        setFetchedData([]);
        setTotalItems(0);
      }
    } catch (error) {
      setFetchedData([]);
    } finally {
      setDataLoading(false);
    }
  }

  const handleAddTemplate = () => {
    navigate("/template");
  };

  const handleViewDetails = (details) => {
    setTemplateDetails(JSON.parse(details));
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      const params = new URLSearchParams(location.search);
      params.set("page", page);
      navigate(
        {
          pathname: location.pathname,
          search: params.toString(),
        },
        { replace: false }
      );
      fetchData(page, searchTerm);
    }
  };

  async function handleDelete(id) {
    if (!window.confirm("Are you sure you want to delete this template?")) return;
    
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "deleteTemplate";

      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("id", id);

      const response = await api.post("templates/templateCurl", fd);
      toast.success("Template deleted successfully");
      fetchData(currentPage, searchTerm);
    } catch (error) {
      toast.error("Error deleting template.");
    } finally {
      setLoading(false);
    }
  }

  const createPagination = () => {
    const pageNumbers = [];
    const range = 2;
    const maxPageNumber = totalPages;

    pageNumbers.push(1);
    if (currentPage > range + 2) {
      pageNumbers.push("...");
    }
    for (
      let i = Math.max(currentPage - range, 2);
      i <= Math.min(currentPage + range, maxPageNumber - 1);
      i++
    ) {
      pageNumbers.push(i);
    }
    if (currentPage < maxPageNumber - range - 1) {
      pageNumbers.push("...");
    }
    if (maxPageNumber > 1) {
      pageNumbers.push(maxPageNumber);
    }

    return pageNumbers;
  };

  const menuItemStyle = {
    padding: "10px 14px",
    cursor: "pointer",
    fontSize: "13px",
    borderBottom: "1px solid #f1f1f1",
    transition: "background 0.2s",
    color: "#333",
  };

  const isLastRows = (index) => {
    return index >= fetchedData.length - 2;
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f8fafc",
      padding: "24px",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
    }}>
      {userPermissions.is_view === "0" ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <h4 style={{ color: "#dc2626" }}>Permission Denied</h4>
        </div>
      ) : (
        <>
          {/* Header Section */}
          <div style={{ marginBottom: "32px" }}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px",
              flexWrap: "wrap",
              gap: "16px"
            }}>
              <div>
                <h1 style={{
                  fontSize: "28px",
                  fontWeight: "700",
                  color: "#1e293b",
                  margin: 0
                }}>
                  Template Management
                </h1>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "14px",
                  color: "#64748b",
                  marginTop: "4px"
                }}>
                  <Link to="/" style={{ color: "#64748b", textDecoration: "none" }}>Home</Link>
                  <span>/</span>
                  <span style={{ color: "#3E80F9", fontWeight: "500" }}>Template Details</span>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                {/* Search Bar */}
                <div style={{ position: "relative" }}>
                  <div style={{
                    position: "absolute",
                    left: "16px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#94a3b8",
                    zIndex: 1
                  }}>
                    <MagnifyingGlass size={20} />
                  </div>
                  <input
                    type="text"
                    placeholder="Search templates..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      padding: "12px 20px 12px 48px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      fontSize: "14px",
                      width: "320px",
                      outline: "none",
                      transition: "all 0.2s",
                      background: "#fff",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                    }}
                    onKeyDown={(e) => e.key === "Enter" && fetchData(1, searchTerm)}
                  />
                </div>

                {userPermissions.is_add === "1" && (
                  <button
                    onClick={handleAddTemplate}
                    style={{
                      background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
                      color: "#fff",
                      border: "none",
                      padding: "12px 24px",
                      borderRadius: "12px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.3s",
                      boxShadow: "0 2px 8px rgba(62, 128, 249, 0.3)"
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "translateY(-2px)"}
                    onMouseLeave={(e) => e.target.style.transform = "translateY(0)"}
                  >
                    <Plus size={20} weight="bold" />
                    Add New Template
                  </button>
                )}
              </div>
            </div>
          </div>

         

          {/* Templates Table */}
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            marginTop: "16px"
          }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: "600px",
                fontSize: "13px"
              }}>
                <thead
                  style={{
                    background: "#f8fafc",
                    borderBottom: "2px solid #e5e7eb"
                  }}
                >
                  <tr>
                    <th
                      style={{
                        width: "48px",
                        minWidth: "48px",
                        maxWidth: "48px",
                        padding: "14px 8px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      #
                    </th>

                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Template Details
                    </th>

                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Sections
                    </th>

                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Questions
                    </th>

                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>

                {dataLoading ? (
                  <TableLoader rows={6} columns={5} />
                ) : (
                  <tbody>
                    {fetchedData.length === 0 ? (
                      <tr>
                        <td colSpan={5} style={{ padding: "40px", textAlign: "center" }}>
                          <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px",
                            color: "#94a3b8"
                          }}>
                            <div style={{
                              fontSize: "36px",
                              background: "#f1f5f9",
                              width: "60px",
                              height: "60px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                              📄
                            </div>
                            <div style={{ fontSize: "16px", fontWeight: "600", color: "#475569" }}>
                              No templates found
                            </div>
                            <div style={{ fontSize: "13px", maxWidth: "300px" }}>
                              {searchTerm || activeTab || templateFilter
                                ? "Try adjusting your filters"
                                : "Create your first template"}
                            </div>
                            {!searchTerm && !activeTab && !templateFilter && userPermissions.is_add === "1" && (
                              <button
                                onClick={handleAddTemplate}
                                style={{
                                  background: "#3E80F9",
                                  color: "#fff",
                                  border: "none",
                                  padding: "8px 20px",
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  cursor: "pointer",
                                  marginTop: "8px"
                                }}
                              >
                                Create First Template
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ) : (
                      fetchedData.map((template, index) => (
                        <tr key={template.id} style={{
                          borderBottom: "1px solid #f1f5f9",
                          transition: "background 0.2s"
                        }}>
                          <td
                            style={{
                              width: "48px",
                              minWidth: "48px",
                              maxWidth: "48px",
                              padding: "6px",
                              fontSize: "12px",
                              color: "#64748b",
                              fontWeight: "500",
                              textAlign: "center",
                              whiteSpace: "nowrap"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                borderRadius: "6px",
                                background: "#f1f5f9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "600",
                                fontSize: "12px",
                                color: "#475569",
                                margin: "0 auto"
                              }}
                            >
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </div>
                          </td>
                          
                          <td style={{ padding: "12px" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                              <div style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#1e293b",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                flexWrap: "wrap"
                              }}>
                                <span style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: "250px"
                                }}>
                                  {template.name}
                                </span>
                                {template.totalSections > 1 && (
                                  <span style={{
                                    background: "#f0f9ff",
                                    color: "#0369a1",
                                    fontSize: "10px",
                                    fontWeight: "600",
                                    padding: "2px 8px",
                                    borderRadius: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "2px",
                                    whiteSpace: "nowrap"
                                  }}>
                                    {template.totalSections} Sections
                                  </span>
                                )}
                              </div>
                              <div style={{
                                fontSize: "12px",
                                color: "#64748b",
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                flexWrap: "wrap"
                              }}>
                                <span>🆔 ID: {template.id}</span>
                                <span>📅 Created: {new Date().toLocaleDateString('en-GB')}</span>
                              </div>
                            </div>
                          </td>
                          
                          <td
                            style={{
                              padding: "12px",
                              textAlign: "center",
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#334155",
                              whiteSpace: "nowrap"
                            }}
                          >
                            <div style={{
                              background: "#f0f9ff",
                              borderRadius: "8px",
                              padding: "6px 12px",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px"
                            }}>
                              <span style={{ fontWeight: "600" }}>{template.totalSections}</span>
                            </div>
                          </td>
                          
                          <td
                            style={{
                              padding: "12px",
                              textAlign: "center",
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#334155",
                              whiteSpace: "nowrap"
                            }}
                          >
                            <div style={{
                              background: "#f0fdf4",
                              borderRadius: "8px",
                              padding: "6px 12px",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px"
                            }}>
                              <span style={{ fontWeight: "600" }}>{template.totalQuestions}</span>
                            </div>
                          </td>
                          
                          <td style={{ padding: "12px", textAlign: "center", position: "relative" }}>
                            <div style={{
                              display: "flex",
                              gap: "6px",
                              justifyContent: "center",
                              flexWrap: "wrap"
                            }}>
                              {userPermissions.is_edit === "1" && (
                                <button
                                  onClick={() => handleViewDetails(template.details)}
                                  title="View Details"
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "8px",
                                    border: "none",
                                    background: "#eff6ff",
                                    color: "#3b82f6",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "all 0.2s",
                                    flexShrink: 0
                                  }}
                                >
                                  <Eye size={14} />
                                </button>
                              )}

                              {userPermissions.is_delete === "1" && (
                                <button
                                  onClick={() => handleDelete(template.id)}
                                  title="Delete Template"
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "8px",
                                    border: "none",
                                    background: "#fef2f2",
                                    color: "#dc2626",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "all 0.2s",
                                    flexShrink: 0
                                  }}
                                >
                                  <Trash size={14} />
                                </button>
                              )}

                           

                             
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                )}
              </table>
            </div>

            {/* Compact Pagination */}
            {!dataLoading && fetchedData.length > 0 && (
              <div style={{
                padding: "16px 20px",
                borderTop: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "12px",
                fontSize: "13px"
              }}>
                <div style={{ color: "#64748b" }}>
                  Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}
                </div>
                <div style={{ display: "flex", gap: "4px" }}>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === 1 ? "#f1f5f9" : "#fff",
                      color: currentPage === 1 ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    ← Prev
                  </button>

                  <div style={{ display: "flex", gap: "2px" }}>
                    {createPagination().map((page, index) => (
                      <button
                        key={index}
                        onClick={() => typeof page === "number" && handlePageChange(page)}
                        style={{
                          padding: "6px 10px",
                          background: currentPage === page ? "#3E80F9" : "#fff",
                          color: currentPage === page ? "#fff" : "#334155",
                          border: "1px solid #e5e7eb",
                          borderRadius: "6px",
                          cursor: typeof page === "number" ? "pointer" : "default",
                          fontSize: "12px",
                          minWidth: "32px",
                          transition: "all 0.2s",
                          fontWeight: currentPage === page ? "600" : "500"
                        }}
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === totalPages ? "#f1f5f9" : "#fff",
                      color: currentPage === totalPages ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    Next →
                  </button>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <ToastContainer position="top-right" autoClose={3000} />

<Modal
  size="lg"
  show={show}
  onHide={handleClose}
  backdrop="static"
  keyboard={false}
  centered
>
  <Modal.Header
    closeButton
    style={{
      borderBottom: "1px solid #e5e7eb",
      padding: "24px 28px",
      background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
      color: "#fff",
    }}
  >
    <div>
      <Modal.Title
        style={{
          fontSize: "20px",
          fontWeight: "700",
          marginBottom: "4px",
          color: "#fff",
        }}
      >
        📋 Template Details
      </Modal.Title>

      <div
        style={{
          fontSize: "14px",
          opacity: 0.9,
        }}
      >
        View comprehensive template structure and configuration
      </div>
    </div>
  </Modal.Header>

  <Modal.Body
    style={{
      padding: "28px",
      maxHeight: "60vh",
      overflowY: "auto",
      background: "#f8fafc",
    }}
  >
    {templateDetails ? (
      <div>
        {Object.entries(templateDetails.sections).map(
          ([sectionKey, sectionValue]) => (
            <div key={sectionKey} className="mb-3 table-responsive">
              <div className="d-flex justify-content-between align-items-center">
                <h5
                  className="mb-0"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#1e293b",
                  }}
                >
                  {`Section ${sectionValue.sectionNumber}:`}
                </h5>

                <div>
                  <h6
                    className="d-inline me-3"
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#166534",
                    }}
                  >
                    {`Positive Questions: ${sectionValue.positive},`}
                  </h6>

                  <h6
                    className="d-inline"
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#dc2626",
                    }}
                  >
                    {`Negative Questions: ${sectionValue.negative}`}
                  </h6>
                </div>
              </div>

              <table
                className="table table-bordered mt-2"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <thead
                  style={{
                    backgroundColor: "#f8fafc",
                    borderBottom: "2px solid #e5e7eb",
                  }}
                >
                  <tr>
                    <th
                      style={{
                        padding: "12px 16px",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#475569",
                      }}
                    >
                      Included Subjects
                    </th>

                    <th
                      style={{
                        padding: "12px 16px",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#475569",
                      }}
                    >
                      Question Types
                    </th>

                    <th
                      style={{
                        padding: "12px 16px",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#475569",
                      }}
                    >
                      Total Questions
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td
                      style={{
                        padding: "12px 16px",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#334155",
                      }}
                    >
                      {Object.values(sectionValue.subjects)
                        .map((subject) => subject.subjectName)
                        .join(", ")}
                    </td>

                    <td
                      style={{
                        padding: "12px 16px",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#334155",
                      }}
                    >
                      {Array.isArray(sectionValue.questionTypeName)
                        ? sectionValue.questionTypeName.join(", ")
                        : sectionValue.questionTypeName || "-"}
                    </td>

                    <td
                      style={{
                        padding: "12px 16px",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#334155",
                        textAlign: "center",
                      }}
                    >
                      {sectionValue.totalQuestions}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )
        )}
      </div>
    ) : (
      <div
        style={{
          textAlign: "center",
          padding: "40px 20px",
          color: "#64748b",
        }}
      >
        No details available
      </div>
    )}
  </Modal.Body>

  <Modal.Footer
    style={{
      borderTop: "1px solid #e5e7eb",
      padding: "24px 28px",
      background: "#f8fafc",
    }}
  >
    <Button
      variant="secondary"
      onClick={handleClose}
      style={{
        background: "#f1f5f9",
        color: "#475569",
        border: "none",
        padding: "10px 24px",
        borderRadius: "10px",
      }}
    >
      Close
    </Button>
  </Modal.Footer>
</Modal>
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          *:focus {
            outline: 2px solid #3E80F9;
            outline-offset: 2px;
          }
          
          button:hover {
            transform: translateY(-2px);
          }
          
          .modal-content {
            border-radius: 20px;
            border: none;
            box-shadow: 0 20px 60px rgba(0,0,0,0.15);
          }
          
          input:hover, select:hover {
            border-color: #94a3b8 !important;
          }
          
          input:focus, select:focus {
            border-color: #3E80F9 !important;
            box-shadow: 0 0 0 3px rgba(62, 128, 249, 0.1) !important;
          }
        `}
      </style>
    </div>
  );
};

export default TemplateDetails;